import { GameReplicatedTimeout, GameReplicatedTimeoutConfig } from "./GameReplicatedTimeout";
export class ReplicatedLockRecord {
    constructor() {
        this.replicatedLocks = Object.create(null);
    }
    _addReplicatedLock(key, lock) {
        if (this.replicatedLocks[key] !== undefined) {
            this.replicatedLocks[key].cancel();
        }
        this.replicatedLocks[key] = lock;
    }
    _removeReplicatedLock(key) {
        delete this.replicatedLocks[key];
    }
    isLocked(key) {
        return this.replicatedLocks[key] !== undefined;
    }
}
export class ReplicatedLock extends GameReplicatedTimeout {
    onStart() {
        super.onStart();
        this.context.locks._addReplicatedLock(this.data.key, this);
    }
    callback() {
        this.context.locks._removeReplicatedLock(this.data.key);
    }
}
export function createReplicatedLock(data, context) {
    return context.createReplicatedTimeout('ReplicatedLock', data, []);
}
export const ReplicatedLockConfig = new GameReplicatedTimeoutConfig('ReplicatedLock', ReplicatedLock);
//# sourceMappingURL=ReplicatedLock.js.map